import { render } from "./ImportarModelo.vue?vue&type=template&id=516183c7&scoped=true"
import script from "./ImportarModelo.vue?vue&type=script&lang=js"
export * from "./ImportarModelo.vue?vue&type=script&lang=js"

import "./ImportarModelo.vue?vue&type=style&index=0&id=516183c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516183c7"]])

export default __exports__